import React from 'react'
import './Splinner.css'

export default function Splinner() {
  return (
    <div className='splinner-main'>
      <span class="spinner"></span>
    </div>
  )
}
